import { useSettings } from '@wix/tpa-settings/react';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import React, { FC } from 'react';
import { StripCard } from 'wix-ui-tpa/cssVars';
import { ImageShapeOptions } from '../../../../../../types/types';
import { useAddVisibilityClass } from '../../../../hooks/useAddVisibilityClass';
import { useLayoutPerBpInWidget } from '../../../../hooks/useLayoutPbpInWidget';
import settingsParams from '../../../../settingsParams';
import { DataHooks } from '../consts';
import { ServiceLayoutProps } from '../ServiceCard';
import { classes, st } from './Strip.st.css';

export const Strip: FC<ServiceLayoutProps> = (props) => {
  const { image, info } = props;
  const { isMobile } = useEnvironment();
  const { layoutStylePerBpEnable: isLayoutPbpEnabled } =
    useLayoutPerBpInWidget();
  const { addVisibilityClassForLayoutPbp } = useAddVisibilityClass();
  const settings = useSettings();

  return (
    <StripCard
      data-hook={DataHooks.STRIP}
      media={image}
      info={info}
      className={addVisibilityClassForLayoutPbp(
        st(classes.root, {
          isMobile,
          imageSize: settings.get(settingsParams.serviceImageSize),
          isLayoutPbpEnabled,
        }),
        classes.serviceImageVisibility,
        'isServiceImageVisible',
      )}
      roundMedia={
        settings.get(settingsParams.serviceImageShape) ===
        ImageShapeOptions.ROUND
      }
    />
  );
};
